export default __webpack_public_path__ + "img/estrella.92fbaf5f.svg";